// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://owlyalitoeiisdeyknne.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im93bHlhbGl0b2VpaXNkZXlrbm5lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkzOTAyMzgsImV4cCI6MjA2NDk2NjIzOH0.9LxBVYsqn61yD2C_Q_6U4_iVUJrDOw-yLFHvNOz-peA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);